//Totem type

export const PRIMARY: string = 'primary';
export const SECONDARY: string = 'secondary';

//Order type

export const PUNCTUAL: string = 'punctual';
export const RECURRING: string = 'recurring';
